import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { AddReferenceKeys } from "i18n/i18next";
import { IconSizeType, LegacyButton } from "mds/components/LegacyButton";
import { AddPlusIcon } from "mds/icons";

export interface AddIconButtonProps {
  onClick: () => void;
  reference: AddReferenceKeys;
  eventPrefix?: string;
  size?: IconSizeType;
}

export const ToolbarAddIconButton: FC<AddIconButtonProps> = ({
  onClick,
  reference,
  eventPrefix,
  size = "s",
}) => {
  return (
    <LegacyButton
      className="p-2"
      eventName={eventPrefix ? `${eventPrefix}Add` : undefined}
      kind="tertiary"
      size={size}
      title={t("edit_delete_widget.add", { context: reference })}
      iconOnly
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <AddPlusIcon />
    </LegacyButton>
  );
};
